export default __webpack_public_path__ + "static/media/uploader-abbottLite-problem-2.4be8167b.png";